document.addEventListener('DOMContentLoaded', function() {
  var pageNot = document.querySelector('.m-page404');
  var pageNotCont = pageNot.querySelector('p')
  if (pageNot) {
    const words = ["somerton", "cranbourne", "truganina", "pakenham", "toowoomba", "townsville"];
    const url = window.location.href;
    const urlParts = new URL(url).pathname.split('/').pop().toLowerCase().split('-');
    urlParts.forEach(part => {
      if (words.includes(part)) {
        pageNotCont.innerHTML = 'Sorry this product is not available at this location. <a href="/pages/contact-us" style="text-decoration: underline;">Contact us</a> to request this product';
        pageNotCont.style.fontSize = '30px'
      }
    });
  }
  pageNotCont.style.fontSize = '30px'
});

var buttonPopup = document.querySelectorAll('.location_popup_col.button');
if(buttonPopup.length){ 
  buttonPopup.forEach(function (button) {
      var parent = button.parentElement.parentElement.parentElement;
      if (parent.classList.contains('location_popup')) {
          parent.classList.add('button');
      }
  });
}


document.addEventListener('DOMContentLoaded', function() {
    function getCookie(name) {
        let cookieArr = document.cookie.split(';');
        for (let cookie of cookieArr) {
            let cookiePair = cookie.trim();
            if (cookiePair.indexOf(name + '=') === 0) {
                return cookiePair.substring(name.length + 1);
            }
        }
        return null;
    }
    function setCookie(name, value, maxAgeDays) {
        document.cookie = `${name}=${value}; path=/; max-age=${maxAgeDays * 86400}`;
    }
    function deleteCookie(name) {
        document.cookie = `${name}=; path=/; max-age=0`;
    }
    function updateLinkWithLocation(location) {
        let menuItems = document.querySelectorAll(
            '.location_ul li[data-name="decking"], ' +
            '.m-menu-drawer__navigation li[data-name="decking"], ' +
            '.m-menu-drawer__navigation li[data-name="artificial-grass"], ' +
            '.m-submenu-mobile li[data-name="internal"], ' +
            '.m-submenu-mobile li[data-name="external"], ' +
            '.location_ul li[data-name="internal"], ' +
            '.location_ul li[data-name="external"], ' +
            '.location_ul li[data-name="artificial-grass"], ' +
            '.collection_btn_inner[data-name="external"], ' +
            '.collection_btn_inner[data-name="internal"], ' +
            '.m-collection-card__title[data-name="external"], ' +
            '.m-collection-card__title[data-name="internal"], ' +
            '.m-button[data-name="artificial-grass"], ' +
            '.m-button[data-name="decking"], ' +
            '.locationLink[data-name="artificial-grass"], ' +
            '.locationLink[data-name="decking"]'
        );
        
        menuItems.forEach(function(menuItem) {
            let dataName = menuItem.getAttribute('data-name');
            let url = '';

            switch (dataName) {
                case 'decking':
                    url = `/pages/composite-decking-in-${location}`;
                    break;
                case 'internal':
                    url = `/pages/internal-cladding-in-${location}`;
                    break;
                case 'external':
                    url = `/pages/external-wall-cladding-${location}`;
                    break;
                case 'artificial-grass':
                    url = `/pages/artificial-grass-${location}`;
                    break;
            }

            let link = menuItem.querySelector('a');
            if (link) {
                link.href = url;
            } else {
                menuItem.setAttribute('href', url);
            }
        });

        document.querySelectorAll('.location_select[data-name="select-location"] span').forEach(function(span) {
            span.innerText = location;
          });
    }

    let storedLocation = getCookie('selected_location');
    if (storedLocation) {
        updateLinkWithLocation(storedLocation);
    }

   function removeProduct() {
      const qldLocations = ["somerton", "cranbourne", "truganina", "pakenham"];
      const selectedLocation = getCookie("selected_location");
  
      if (selectedLocation && qldLocations.includes(selectedLocation)) {
          document.querySelectorAll('div[data-product="usingQLD"], li[data-product="usingQLD"]').forEach(function(el) {
              el.parentElement?.remove();
          });
      } else {
        document.querySelectorAll('div[data-product="usingQLD"], li[data-product="usingQLD"]').forEach(function(el) {
            const productLink = el.querySelector('.m-product-card__link');
            if (productLink && productLink.href.includes("-tv")) {
                if (selectedLocation === "townsville") {
                    document.querySelectorAll('div[data-product="usingQLD"], li[data-product="usingQLD"]').forEach(function(elem) {
                        const link = elem.querySelector('.m-product-card__link');
                        if (link && link.href.includes("-tv")) {
                            elem.style.display = "block";
                        } else {
                            elem.parentElement?.remove();
                        }
                    });
                }
                else if (selectedLocation === "toowoomba") {
                    el.parentElement?.remove();
                }
            }
        });
        document.querySelectorAll('div[data-product="notQLD"], li[data-product="notQLD"]').forEach(function(el) {
            el.parentElement?.remove();
        });
      }
    }
    setInterval(removeProduct, 100);
    removeProduct();


    
    if (getCookie('location_popup_closed') !== 'true') {
        document.querySelector('.location_popup').style.display = 'flex';
        document.body.classList.add('location_body');
    } else {
        document.querySelector('.location_popup').style.display = 'none';
        document.body.classList.remove('location_body');
    }

      document.querySelectorAll('.location_popup_col').forEach(function(col) {
        col.addEventListener('click', function() {
            let selectedLocation = this.querySelector('h3').innerText.toLowerCase();
            localStorage.setItem('selected_location', selectedLocation);
            setCookie('selected_location', selectedLocation, 1);
            setCookie('location_popup_closed', 'true', 1);
            document.querySelector('.location_popup').style.display = 'none';
            document.body.classList.remove('location_body');
            updateLinkWithLocation(selectedLocation);
            const qldLocations = ["somerton", "cranbourne", "truganina", "pakenham"];
            const urlContainsQld = window.location.href.includes('qld');
            const urlContainsPro = window.location.href.includes('products');
            let currentUrl = window.location.href;
            setTimeout(function() {
                if (urlContainsPro && document.querySelector('body.template-404')) {
                    window.location.href = '/';
                }
            }, 500);
            let firstProductTitleParer = document.querySelector('.m-product-title');
              if (firstProductTitleParer) {
                  let firstProductTitle = firstProductTitleParer.innerText;
      
                  if (selectedLocation === 'townsville' || selectedLocation === 'toowoomba') {
                      let targetProducts = document.querySelectorAll('#collection_somerton .' + selectedLocation + ' p');
                      let productFound = false;
      
                      targetProducts.forEach(function(product) {
                          if (product.innerText.includes(firstProductTitle)) {
                              productFound = true;
                          }
                      });
      
                      if (productFound) {
                          window.location.reload();
                      } else {
                          window.location.href = '/';
                      }
                  }
              }

            if (qldLocations.includes(selectedLocation) && urlContainsPro && currentUrl.endsWith("qld")) {
                let updatedUrl = currentUrl.replace(/-qld$/, '');
                window.history.replaceState(null, null, updatedUrl);
                window.location.reload();
            } else if (!qldLocations.includes(selectedLocation) && urlContainsPro && !currentUrl.endsWith("qld")) {
                let updatedUrl = currentUrl + "-qld";
                window.history.replaceState(null, null, updatedUrl);
                window.location.reload();
            }
            if ((!qldLocations.includes(selectedLocation) && urlContainsQld) ||
                (qldLocations.includes(selectedLocation) && !urlContainsQld && urlContainsPro)) {
                window.location.reload();
                return;
            } else {
                const locationWords = ["somerton", "cranbourne", "truganina", "pakenham", "toowoomba", "townsville"];
                const currentLocationWord = currentUrl.split('/').pop();
                const currentLocationWordLast = currentLocationWord.split('-').pop();
                if (locationWords.includes(currentLocationWordLast)) {
                    let updatedUrl = currentUrl.replace(currentLocationWordLast, selectedLocation);
                    window.history.replaceState(null, null, updatedUrl);
                    console.log('Updated location:', selectedLocation);
                    window.location.reload();
                } else {
                    setTimeout(function() { 
                        const urlContainsColl = window.location.href.includes('collections');
                        if (urlContainsColl && !document.querySelector('#CollectionProductGrid .m-product-item')) {
                            window.location.href = '/';
                        } else {
                            console.log('Selected location:', selectedLocation);
                            window.location.reload();
                        }
                    }, 1000);
                }
            }
        });
    });

    // Handle location reset on selection click
    document.querySelectorAll('.location_select[data-name="select-location"]').forEach(function(li) {
        li.addEventListener('click', function() {
            setTimeout(function() {
                deleteCookie('selected_location');
                deleteCookie('location_popup_closed');
                localStorage.removeItem('selected_location');

                document.querySelector('.location_popup').style.display = 'flex';
                document.body.classList.add('location_body');
            }, 500);
        });
    });

     // let previousLocation = getCookie('selected_location');
     //  function changeLocation() {
     //      let currentLocation = getCookie('selected_location');
     //      if (currentLocation && currentLocation !== previousLocation) {
     //          previousLocation = currentLocation;
     //          window.location.reload();
     //      }
     //  }
     //  setInterval(changeLocation, 1000);
  
      function colelctionmmor() {
      const urlContainsColl = window.location.href.includes('collections');
      const urlContainsCollPro = document.querySelector('.m-product-item');
      const selectedLocation = getCookie("selected_location");
      const words = ["somerton", "cranbourne", "truganina", "pakenham", "toowoomba", "townsville"];
      const url = window.location.href;
      const urlParts = new URL(url).pathname.split('/').pop().toLowerCase().split('-');
    
      let locationFound = false;
    
      urlParts.forEach(part => {
        if (words.includes(part)) {
          locationFound = true;
          if (selectedLocation !== part && urlContainsColl && !urlContainsCollPro) {
            console.log('Location mismatch, redirecting to home page...');
            window.location.href = '/';
          }
        }
      });
    
      if (!locationFound) {
        console.log('No location match or URL does not contain "collections".');
      }
    }
    let previousLocation = getCookie("selected_location");
    
    function monitorLocationChange() {
      const currentLocation = getCookie("selected_location");
    
      if (currentLocation !== previousLocation) {
        console.log('Location has changed, checking conditions...');
        colelctionmmor();
        previousLocation = currentLocation;
      }
    }
    
    setInterval(monitorLocationChange, 1000);

  
    // Handle product updates based on QLD-specific logic
    const qldLocations = ["somerton", "cranbourne", "truganina", "pakenham"];
    const qldLocationValue = getCookie("selected_location");
    const urlContainsPro = window.location.href.includes('products');
    const urlContainsQld = window.location.href.includes('qld');

    if (qldLocations.includes(qldLocationValue) && urlContainsQld && urlContainsPro) {
        window.location.href = '/';
    } else if (!qldLocations.includes(qldLocationValue) && urlContainsQld) {
        console.log("Not a QLD location, continuing.");
    }
    if (urlContainsPro && document.querySelector('body.template-404')) {
        window.location.href = '/';
   }
});
